<div>
  <div class="text-xs mb-10 space-y-2">
    <p>Nessa zona será possível remover todas as ocorrências criadas por essa conta. Por razões de seguranças precisamos
      garantir que o utilizador tem certeza dessa operação</p>
  </div>

  <form method="POST" [formGroup]="form">

    <div class="space-y-8">

      <div class="mt-2">
        <app-text-input [formGroup]="form" type="text" id="verification"
                        [value]="form.value?.verification"
                        [hideCounter]="true"
                        placeholder="Texto de verificação"
                        label="Texto de verificação">
        </app-text-input>
        <p class="text-xs my-2">Adicione o seguinte texto no campo abaixo "<span
          class="font-bold underline">{{ verificationText }}</span>"</p>
      </div>

    </div>
    <!-- submit button -->
    <div class="my-4">
      <app-ae-button variant="danger"
        label="Remover Ocorrências"
        [disabled]="!form.valid || form.get('verification').value !== verificationText"
        [loading]="isLoading"
        (buttonClick)="apiOnRemove()"
        size="sm" styleClass="w-full">
      </app-ae-button>
    </div>
  </form>
</div>
